import { SET_ADMIN_LIST } from './types.js'

export default {
  [SET_ADMIN_LIST] (state, admin_list) {
    state.admin_list = admin_list
  }
}
